import { Link, Outlet } from 'react-router';
import { PermissionsGate } from '../auth/PermissionsGate';
import { useSession } from '../auth/session';
import { LocaleSwitcher } from '../i18n/LocaleSwitcher';
import { useTranslate } from '../i18n/useTranslate';
import { MainNav } from './MainNav';
import { TenantGate } from '../tenant/TenantGate';
import { PlatformTenantPicker } from '../platform/PlatformTenantPicker';
import { TenantSwitcher } from '../tenant/TenantSwitcher';

/**
 * Korumalı bölgenin kabuğu.
 *
 * İki kapı iç içe:
 *   TenantGate      — kurum seçilmeden /me/permissions 403 döner (SEOAI-78)
 *   PermissionsGate — izinler GELENE KADAR menü/sayfa çizilmez (SEOAI-47)
 */
export function AppLayout() {
  const t = useTranslate();
  const clear = useSession((s) => s.clear);

  return (
    <div className="shell">
      <header>
        {/*
          * Marka bağlantısı KÖKE gider; hedefi LandingRedirect çözer. Sabit
          * /projects idi ve project.view izni olmayan kullanıcı logoya basınca
          * Forbidden'a düşüyordu — açılış ve "geri dön" düzeltilmişken üçüncü
          * kopya olarak burada kalmıştı (SEOAI-47 incelemesi).
          */}
        <Link to="/" className="brand">{t('app.title')}</Link>

        <nav>
          {/* Platform denetimi AYRI durur: üyelik yoluyla gelen kurum
              değiştiriciyle aynı kutuda gösterilmez (SEOAI-81). */}
          <PlatformTenantPicker />
          <TenantSwitcher />
          <LocaleSwitcher />
          <button type="button" onClick={clear}>{t('auth.logout')}</button>
        </nav>
      </header>

      <TenantGate>
        {/* Menü kapıların İÇİNDE: izinler kurum seçilmeden okunamaz ve
            yüklenmeden karar verilemez. */}
        <PermissionsGate>
          <div className="body">
            <MainNav />
            <main>
              <Outlet />
            </main>
          </div>
        </PermissionsGate>
      </TenantGate>
    </div>
  );
}
